import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTemplateVersionUploadFailedAction = {
	type: 'DOCUMENT_TEMPLATE_VERSION_UPLOAD_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTemplateVersionUploadFailedAction => ({
	type: 'DOCUMENT_TEMPLATE_VERSION_UPLOAD_FAILED',
	payload,
});
